import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCq0kkMXZXTUKzQdtBEAQQtwKF0quDIPzk",
  authDomain: "capstone-13824.firebaseapp.com",
  projectId: "capstone-13824",
  storageBucket: "capstone-13824.appspot.com",
  messagingSenderId: "65060656355",
  appId: "1:65060656355:web:6a6fe71548d8bfbd5be1d6",
  measurementId: "G-CNBX65NYQN",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
